
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { CreateFacilityOrderTemplateUSIntakeNewFlowModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { CreateFacilityOrderTemplateUSIntakeNewFlowModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new CreateFacilityOrderTemplateUSIntakeNewFlowModalStore(rootStore, componentProps), 'createFacilityOrderTemplateUSIntakeNewFlowModalStore')
@observer
class CreateFacilityOrderTemplateUSIntakeNewFlowModal extends React.Component {
    render() {
        return <CreateFacilityOrderTemplateUSIntakeNewFlowModalTemplate {...this.props} />
    }
}

export default CreateFacilityOrderTemplateUSIntakeNewFlowModal;
